var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RowViewModel } from "survey-creator-core";
import * as React from "react";
import { ReactElementFactory } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
var RowWrapper = /** @class */ (function (_super) {
    __extends(RowWrapper, _super);
    function RowWrapper(props) {
        return _super.call(this, props) || this;
    }
    RowWrapper.prototype.createModel = function (props) {
        if (!!this.model) {
            this.model.dispose();
        }
        this.model = new RowViewModel(props.componentData.creator, props.row, null);
    };
    RowWrapper.prototype.getUpdatedModelProps = function () {
        return ["row", "componentData"];
    };
    RowWrapper.prototype.getStateElement = function () {
        return this.model;
    };
    RowWrapper.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.subscribeElementChanges();
    };
    RowWrapper.prototype.componentWillUnmount = function () {
        this.model.unsubscribeElementChanges();
        _super.prototype.componentWillUnmount.call(this);
    };
    RowWrapper.prototype.render = function () {
        return (React.createElement("div", { key: "svc-row-" + this.props.row.id, className: this.model.cssClasses },
            React.createElement("div", { className: "svc-row__drop-indicator svc-row__drop-indicator--top" }),
            React.createElement("div", { className: "svc-row__drop-indicator svc-row__drop-indicator--bottom" }),
            this.props.element));
    };
    return RowWrapper;
}(CreatorModelElement));
export { RowWrapper };
ReactElementFactory.Instance.registerElement("svc-row", function (props) {
    return React.createElement(RowWrapper, props);
});
